import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from "@chakra-ui/react";
import React from "react";
const PageHeader = ({ mb, children }) => (_jsx(Box, Object.assign({ px: "6", pt: "12" }, { children: _jsx(Box, Object.assign({ maxW: "7xl", mx: "auto" }, { children: _jsx(Flex, Object.assign({ direction: { base: "column", md: "row" }, justify: "space-between", align: "flex-start", mb: mb || "10", alignItems: "center" }, { children: children })) })) })));
export default PageHeader;
